'use strict';

module.exports = global;



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/implementation.js
 ** module id = 974
 ** module chunks = 0
 **/